import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './VipPage.scss'

const VipPage = () => {
	return (
		<div className="main-content vip-page-container">
			<GamificationBlock
				domId={WIDGETS.vip.domId}
				url={WIDGETS.vip.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default VipPage
